import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useOsOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isOsLoading,
    data: os,
    refetch: refetchOs,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Os options'),
    optionType: OptionsType.OS,
    queryOptions,
  });

  return {
    isOsLoading,
    os,
    refetchOs,
  };
}
